import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "../../font-scale-categories.css";
const classes = {
  h1: styles.h1,
  h2: styles.h2,
  h3: styles.h3,
  h4: styles.h4
};
const H = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    as: givenComponentToRender,
    level,
    ...props
  } = _ref;
  let ComponentToRender = givenComponentToRender;
  const headerClass = `h${level}`;
  if (!ComponentToRender) {
    ComponentToRender = headerClass;
  }
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    ref: ref,
    className: `${className} ${classes[headerClass]}`
  }, props));
});
H.defaultProps = {
  className: ''
};
process.env.NODE_ENV !== "production" ? H.propTypes = {
  /**
   * Additional classes to apply
   */
  className: PropTypes.string,
  /**
   * Component to render. Defaults to h1, h2, h3, h4.
   */
  as: PropTypes.elementType,
  /**
   * Header level to render
   */
  level: PropTypes.oneOf([1, 2, 3, 4]).isRequired
} : void 0;
export default H;